/** Tiny trend line (bars when `bars`), scaled to its own max; decorative next to the figure it explains. */
export function Sparkline({ values, bars = false, tone = 'brand', height = 36 }: { values: number[]; bars?: boolean; tone?: 'brand' | 'green' | 'red' | 'cyan'; height?: number }) {
  const w = 160;
  const h = height;
  const max = Math.max(1, ...values);
  const n = values.length;
  if (n === 0) return null;
  if (bars) {
    const bw = w / n;
    return (
      <svg className={`spark spark-${tone}`} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" aria-hidden>
        {values.map((v, i) => (
          <rect key={i} x={i * bw + 0.5} y={h - (v / max) * (h - 2)} width={Math.max(1, bw - 1.5)} height={(v / max) * (h - 2)} rx={1} />
        ))}
      </svg>
    );
  }
  const pts = values.map((v, i) => [n === 1 ? w : (i / (n - 1)) * w, h - 2 - (v / max) * (h - 4)] as const);
  const line = pts.map(([x, y], i) => `${i ? 'L' : 'M'}${x.toFixed(1)} ${y.toFixed(1)}`).join(' ');
  return (
    <svg className={`spark spark-${tone}`} viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" aria-hidden>
      <path d={`${line} L${w} ${h} L0 ${h} Z`} className="area" />
      <path d={line} className="line" />
    </svg>
  );
}
